import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import 'intl';
import 'intl/locale-data/jsonp/en';
import { hmrBootstrap } from './hmr';
import { LOCALE_ID } from '@angular/core';
import { Amplify } from 'aws-amplify';

const awsconfig = require('./aws-exports').default;
Amplify.configure(awsconfig);

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { preserveWhitespaces: true, providers: [{
    provide: LOCALE_ID, useValue: navigator.language}]});

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
} else if (environment.app) {
    document.addEventListener('deviceready', bootstrap, false);
} else {
    bootstrap();
}
